import React from 'react'
import { useTranslation } from 'react-i18next'

import { ShareDropDownMenuButton } from '~/components/features/ShareDropDownMenuButton'
import { Table } from '~/components/features/Table'
import { TableContainer } from '~/components/features/TableContainer'
import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'

import { useRestoringParams } from '../hooks/restoringParams/useRestoringParams'
import { useFigureInfo } from '../hooks/useFigureInfo'
import { useOverlapTableColumns } from '../hooks/useOverlapTableColumns'
import { useOverlapTableInfo } from '../hooks/useOverlapTableInfo'

export const OverlapTable = () => {
  const { t } = useTranslation()
  const columns = useOverlapTableColumns()
  const tableInfo = useOverlapTableInfo()

  const figureInfo = useFigureInfo(t('overlap'))
  const restoringParams = useRestoringParams('overlap')
  const image = <Table columns={columns} tableInfo={tableInfo} />

  return (
    <AmplitudeProvider eventNameSuffix="_overlap">
      <TableContainer
        header={
          <>
            <ShareDropDownMenuButton
              copyToClipboard={{
                columns,
                figureInfo,
                restoringParams,
                tableInfo,
              }}
              downloadAsPng={{ image }}
              getSharedUrl={{ restoringParams }}
              saveDocumentImage={{ figureInfo, image, restoringParams }}
            />
          </>
        }
        id="overlap"
      >
        <Table columns={columns} stickyColumns={2} tableInfo={tableInfo} />
      </TableContainer>
    </AmplitudeProvider>
  )
}
